import React, { useRef, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Tabs,
  Tab,
  IconButton,
  Tooltip,
  CircularProgress,
  Paper,
  Menu,
  MenuItem,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DownloadIcon from "@mui/icons-material/Download";
import ViewColumnOutlinedIcon from "@mui/icons-material/ViewColumnOutlined";
import { tokens, withAlpha } from '../../Common/designTokens';

const OrderPageHeader = ({
  activeTab,
  setActiveTab,
  mainTab,
  setMainTab,
  handleOrderEntryOpen,
  handleCustomizeColumnsOpen,
  handleDownloadCSV,
  csvLoading,
  customizeButtonRef,
  loadingOrders,
  loadingStagingOrders,
  loadingBondChar,
  loadingBondLadder,
}) => {
  // Determine download tooltip based on current tab
  const getDownloadTooltip = () => {
    // Show "Download Orders" only for order tabs (mainTab=0 or mainTab=1)
    if(mainTab === 0){
      if(activeTab === 0){
        return "Download Orders";
      }
    }else if(mainTab === 1){
      return "Download Orders";
    }
    return "Download";
  };

  return (
    <Box sx={{color: tokens.colors.fontColour, padding: "16px", paddingY: "14px", paddingBottom: "0px" }}>
      {/* Top section with title and buttons */}
      <Box sx={{ 
        display: "flex", 
        flexDirection: { xs: "column", sm: "row" },
        alignItems: { xs: "flex-end",  },
        justifyContent: "space-between",
        gap: { xs: 2, sm: 0 },
        borderBottom: `1px solid ${withAlpha(tokens.colors.gray, 0.2)}`,
        height: "48px",

      //   marginBottom: 2
      }}>
        <Tabs
          value={mainTab}
          onChange={(e, newValue) => setMainTab(newValue)}
          textColor="inherit"
          sx={{
            minHeight: '36px',
        //   height: '36px',
            '& .MuiTab-root': {
              color: tokens.colors.fontColour,
              textTransform: 'none',
              // padding: ' 16px',
              
              minHeight: '36px',
              
              // height: '36px',
            },
            '& .Mui-selected': {
              borderRadius: 0,
              backgroundColor: 'transparent !important',
              borderBottom: `1px solid ${tokens.palette.primary} !important`,
            },
          }}
        >

            <Tab sx={{fontSize:"16px", color: tokens.colors.fontColour}} label="Staging Blotter" />

          {loadingOrders ? (
            <Tab
              sx={{fontSize:"16px", color: tokens.colors.fontColour}}
              label={
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  Orders
                  <CircularProgress size={16} sx={{ marginLeft: 1 }} />
                </Box>
              }
            />
          ) : (
            <Tab sx={{fontSize:"16px", color: tokens.colors.fontColour}} label="Orders" />
          )}
        </Tabs>
        <Box sx={{ pb: "4px", display: "flex", gap: 2, flexWrap: "wrap", justifyContent: { xs: "center", sm: "flex-end" } }}>
          <Button
            color="inherit"
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleOrderEntryOpen}
            sx={{
              height: "42px",
              backgroundColor: tokens.colors.defaultGridRowColor,
              color: tokens.colors.fontColour,
              textTransform: "none",
              boxShadow: "none",
              borderRadius: "8px",
              border: `1px solid ${tokens.colors.bodyBorderColor50}`,
              width: { xs: "100%", sm: "auto" },
              "&:hover": { backgroundColor: tokens.colors.defaultGridHoverColor },
            }}
          >
            Order Entry
          </Button>
          <Button
            ref={customizeButtonRef}
            color="inherit"
            variant="contained"
            startIcon={<ViewColumnOutlinedIcon />}
            onClick={handleCustomizeColumnsOpen}
            sx={{
              height: "42px",
              backgroundColor: tokens.colors.defaultGridRowColor,
              color: tokens.colors.fontColour,
              textTransform: "none",
              boxShadow: "none",
              borderRadius: "8px",
              border: `1px solid ${tokens.colors.bodyBorderColor50}`,
              width: { xs: "100%", sm: "auto" },
              "&:hover": { backgroundColor: tokens.colors.defaultGridHoverColor },
            }}
          >
            Columns
          </Button>
          <DownloadMenu
            csvLoading={csvLoading}
            onSelectFormat={handleDownloadCSV}
            tooltip={getDownloadTooltip()}
          />
        </Box>
      </Box>

      
      {/* <Box sx ={{py:'4px',borderBottom: "1px solid rgba(255, 255, 255, 0.2)"}}></Box> */}

      {/* Sub tabs - only show for Staging Blotter */}
      {mainTab === 0 && (
        <Box sx={{ 
          // backgroundColor: 'rgba(33, 33, 33, 1)', 
          pt: 0.5,
          borderBottom: `1px solid ${tokens.colors.bodyBorderColor50}`
        }}>
          <Tabs
            value={activeTab}
            onChange={(e, newValue) => setActiveTab(newValue)}
            textColor="primary"
            indicatorColor="primary"
            sx={{
              minHeight: '36px',
              height: '36px',
              "& .MuiTab-root": {
                minHeight: '36px',
                height: '36px',
                padding: '6px 16px',
              },
              "& .MuiTab-root:not(:last-child)": { marginRight: "6px" },
            }}
          >
            <Tab
              className="subtab"
              label={loadingStagingOrders ? (
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  Order
                  <CircularProgress size={16} sx={{ marginLeft: 1 }} />
                </Box>
              ) : "Order"}
              sx={{fontSize:"16px", textTransform: "none", padding: "10px" }}
            />
            <Tab
              className="subtab"
              label={loadingBondChar ? (
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  Characteristic
                  <CircularProgress size={16} sx={{ marginLeft: 1 }} />
                </Box>
              ) : "Characteristic"}
              sx={{fontSize:"16px", textTransform: "none", padding: "10px" }}
            />
            <Tab
              className="subtab"
              label={loadingBondLadder ? (
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  Ladder
                  <CircularProgress size={16} sx={{ marginLeft: 1 }} />
                </Box>
              ) : "Ladder"}
              sx={{fontSize:"16px", textTransform: "none", padding: "10px" }}
            />
          </Tabs>
        </Box>
      )}
    </Box>
  );
};

const DownloadMenu = ({ csvLoading, onSelectFormat, tooltip = "Download" }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <Tooltip title={tooltip}>
        <IconButton
          onClick={(e) => setAnchorEl(e.currentTarget)}
          disabled={csvLoading}
          sx={{
            backgroundColor: tokens.colors.defaultGridRowColor,
            borderRadius: "8px",
            color: tokens.colors.fontColour,
            width: 42,
            height: 42,
            border: `1px solid ${tokens.colors.bodyBorderColor50}`,
            "&:hover": { backgroundColor: tokens.colors.defaultGridHoverColor },
          }}
        >
          {csvLoading ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            <DownloadIcon />
          )}
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem onClick={() => { handleClose(); onSelectFormat("csv"); }}>Download CSV</MenuItem>
        <MenuItem onClick={() => { handleClose(); onSelectFormat("xlsx"); }}>Download Excel</MenuItem>
      </Menu>
    </>
  );
};

export default OrderPageHeader;
